module.exports = __webpack_public_path__ + "ee9dfb51e4b23581526daf05208702ea.png";